import script from "./AccountDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountDetailPage.vue?vue&type=style&index=0&id=525b8b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525b8b0c"]])

export default __exports__